import React, {
  createContext,
  Dispatch,
  ReactNode,
  useContext,
  useReducer,
} from 'react';
import reducer, { Action } from './reducer';

export interface State {
  isLoading: boolean;
  alertModal?: {
    title: string;
    message: string;
    btnLabel?: string;
    onClose?: (reason?: string) => void;
    details?: { summary: string; content: string };
  };
  loginModal?: 'signup' | 'signin' | 'forgetPassword';
  user?: {
    id: string;
    name: string;
    email: string;
    token: string;
    phone?: string;
    photo?: string;
    valid: any;
    [x: string]: any;
  };
}

interface Context extends State {
  dispatch: Dispatch<Action>;
}

const context = createContext({} as Context);

export function useGlobalContext() {
  return useContext(context);
}

interface ProviderProps {
  children: ReactNode;
  initialState: State;
}

export function Provider({ children, initialState }: ProviderProps) {
  const [state, dispatch] = useReducer(reducer, { ...initialState });

  return (
    <context.Provider value={{ ...state, dispatch }}>
      {children}
    </context.Provider>
  );
}
